import { render, staticRenderFns } from "./StoryBoard.vue?vue&type=template&id=065625e3"
import script from "./StoryBoard.vue?vue&type=script&lang=js"
export * from "./StoryBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports